module.exports = __webpack_public_path__ + "img/sage_druid_small.388636be.png";